module.exports = __webpack_public_path__ + "media/images/workation-six-cf31414e870483d7040c413104b013f0.png";